import BOS from './bos';
import CAT from './cat';
import CHI from './chi';
import CIN from './cin';
import CON from './con';
import DVR from './dvr';
import GNY from './gny';
import GOC from './goc';
import GST from './gst';
import INW from './inw';
import KAC from './kac';
import NCA from './nca';
import PHX from './phx';
import PTL from './ptl';
import SET from './set';
import SND from './snd';
import SOC from './soc';
import TRE from './tre';
import TRI from './tri';
import UST from './ust';
import WWN from './wwn';

import { TDAListType } from '../models/tda.model';

const disclaimers: TDAListType = {
  BOS,
  CAT,
  CHI,
  CIN,
  CON,
  DVR,
  GNY,
  GOC,
  GST,
  INW,
  KAC,
  NCA,
  PHX,
  PTL,
  SET,
  SND,
  SOC,
  TRE,
  TRI,
  UST,
  WWN,
};

export default disclaimers;
